import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ticketsAPI } from '../../utils/ticketsApi';

const TicketSupportButton: React.FC = () => {
  const { user } = useAuth();
  const userId = user?.id;
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let cancelled = false;
    let pending = false;
    setUnread(0);
    const load = async () => {
      if (!userId || pending || document.visibilityState !== 'visible') return;
      pending = true;
      try {
        const response = await ticketsAPI.unread();
        if (!cancelled && response.success) setUnread(Math.max(0, response.unread));
      } catch { /* Сбой счётчика не мешает открыть поддержку. */ }
      finally { pending = false; }
    };
    void load();
    const timer = window.setInterval(() => void load(), 20000);
    const refresh = () => void load();
    window.addEventListener('flypix:tickets-changed', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => { cancelled = true; window.clearInterval(timer); window.removeEventListener('flypix:tickets-changed', refresh); document.removeEventListener('visibilitychange', refresh); };
  }, [userId]);
  return <button type="button" className="topbar__icon-btn topbar__support" title={unread ? `Тикетов с непрочитанными сообщениями: ${unread}` : 'Тикеты поддержки'}
    aria-label={unread ? `Открыть тикеты поддержки, тикетов с непрочитанными сообщениями: ${unread}` : 'Открыть тикеты поддержки'} aria-current={location.pathname.startsWith('/tickets') ? 'page' : undefined} onClick={() => navigate('/tickets')}>
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 14v-3a8 8 0 0 1 16 0v3" /><rect x="3" y="11" width="4" height="8" rx="2" /><rect x="17" y="11" width="4" height="8" rx="2" /><path d="M19 19c0 2-3 2-7 2" /></svg>
    {unread > 0 && <span className="topbar__support-badge" aria-hidden="true">{unread > 99 ? '99+' : unread}</span>}
  </button>;
};
export default TicketSupportButton;
